module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/medical-282b4165b07421539cc8db9676462a10.svg";